import { render, staticRenderFns } from "./_PorterageRow.vue?vue&type=template&id=6618b25b"
import script from "./_PorterageRow.vue?vue&type=script&lang=js"
export * from "./_PorterageRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports